@let cropConfigValue = cropConfig();
<div class="h-[80vh] flex flex-col gap-4 p-4">
  <div class="flex gap-4 flex-wrap items-center">
    @if (cropConfigValue.showRotate) {
      <div>
        <button matIconButton type="button" (click)="rotateCanvas('left')">
          <mat-icon customMatSvgIcon="pct-mdi-rotate-left" />
        </button>
        <button matIconButton type="button" (click)="rotateCanvas('right')">
          <mat-icon customMatSvgIcon="pct-mdi-rotate-right" />
        </button>
      </div>
    }
    @if (cropConfigValue.showMaintainAspectRatio) {
      <mat-slide-toggle [formControl]="maintainAspectRatioControl">{{
        'IMAGE_CROPPER.MAINTAIN_ASPECT_RATIO' | transloco
      }}</mat-slide-toggle>
    }
    @if (cropConfigValue.showContainWithinAspectRatio) {
      <mat-slide-toggle [formControl]="containWithinAspectRatioControl">{{
        'IMAGE_CROPPER.CONTAIN_WITHIN_ASPECT_RATIO' | transloco
      }}</mat-slide-toggle>
    }
    @if (cropConfigValue.showAspectRatio) {
      <mat-button-toggle-group name="aspect-ratio" [formControl]="aspectRatioControl">
        @for (aspectRatioOption of aspectRatioOptions; track aspectRatioOption.value) {
          <mat-button-toggle [value]="aspectRatioOption.value">{{
            aspectRatioOption.displayName
          }}</mat-button-toggle>
        }
      </mat-button-toggle-group>
    }
  </div>
  <div class="felx grow min-h-0">
    <image-cropper
      class="border border-gray-400"
      format="webp"
      [aspectRatio]="aspectRatioControl.value"
      [canvasRotation]="canvasRotation()"
      [containWithinAspectRatio]="containWithinAspectRatioControl.value"
      [imageFile]="selectedFile()"
      [maintainAspectRatio]="maintainAspectRatioControl.value"
      (imageCropped)="onImageCropped($event)"
    />
  </div>
  <div class="mt-4 flex justify-end gap-2">
    <ng-container *transloco="let t">
      <button mat-button type="button" (click)="cancelCrop()">{{ t('COMMON.CANCEL') }}</button>
      <button
        color="primary"
        mat-button
        type="button"
        [disabled]="!croppedBlob"
        (click)="confirmCrop()"
      >
        {{ t('COMMON.SAVE') }}
      </button>
    </ng-container>
  </div>
</div>
